import { formatDuration } from "utils/timesheetUtils";

const StatCard = ({ label, value, hint, tone = "default" }) => {
  const tones = {
    default: "border-app-border",
    success: "border-emerald-200 bg-emerald-50",
    warning: "border-amber-200 bg-amber-50",
    info: "border-sky-200 bg-sky-50",
  };

  return (
    <div className={`rounded-lg border bg-app-surface p-4 ${tones[tone] || tones.default}`}>
      <p className="text-xs uppercase tracking-wide text-app-text-muted">{label}</p>
      <p className="mt-1 text-2xl font-semibold text-app-text">{value}</p>
      {hint ? <p className="mt-1 text-xs text-app-text-secondary">{hint}</p> : null}
    </div>
  );
};

const TimesheetStatCards = ({
  employeeCount = 0,
  clockedInCount = 0,
  weekMinutes = 0,
  unpaidMinutes = 0,
  unpaidCount = 0,
}) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
    <StatCard label="Employees" value={employeeCount} hint="Registered staff" />
    <StatCard
      label="Clocked in"
      value={clockedInCount}
      hint="Currently on shift"
      tone={clockedInCount ? "success" : "default"}
    />
    <StatCard
      label="This week"
      value={formatDuration(weekMinutes)}
      hint="Total hours logged"
      tone="info"
    />
    <StatCard
      label="Unpaid"
      value={formatDuration(unpaidMinutes)}
      hint={`${unpaidCount} open ${unpaidCount === 1 ? "entry" : "entries"}`}
      tone={unpaidMinutes ? "warning" : "default"}
    />
  </div>
);

export default TimesheetStatCards;
